import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PropertyTypeActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Property/PropertyType/PropertyTypeBrowser")
	}

	render() {
		return (
			<Activity 
				name="PropertyType"
				RenderedComponent={this.RenderedComponent}
				context="PropertyType"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PropertyTypeActivity)
